module.exports = __webpack_public_path__ + "static/media/ND-2.0-MX5.43da2ab9.webp";